/* Games Workshop EOI form */
(function () {
  function init(root) {
    if (root.dataset.gwEoiReady === 'true') return;
    root.dataset.gwEoiReady = 'true';

    var form = root.querySelector('[data-gw-eoi-form]');
    var banner = root.querySelector('[data-gw-eoi-banner]');
    var deadline = root.querySelector('[data-gw-eoi-deadline]');
    var submit = root.querySelector('[data-gw-eoi-submit]');
    var clear = root.querySelector('[data-gw-eoi-clear]');
    var lineCards = Array.prototype.slice.call(root.querySelectorAll('[data-line-card]'));
    var imageDialog = root.querySelector('[data-gw-eoi-image-dialog]');
    var imageDialogImage = root.querySelector('[data-gw-eoi-image-dialog-image]');
    var imageDialogTitle = root.querySelector('[data-gw-eoi-image-dialog-title]');
    var imageDialogClose = root.querySelector('[data-gw-eoi-image-close]');
    var renderedAt = Date.now();
    var storageKey = 'gw-eoi-state::' + root.dataset.formId;
    var closed = false;

    function field(name) {
      return form.elements.namedItem(name);
    }

    function setBanner(state, message) {
      banner.dataset.state = state;
      banner.textContent = message;
    }

    function isCustomerField(control) {
      return control.name && control.name.indexOf('customer.') === 0;
    }

    function selectedFulfilment() {
      var checked = form.querySelector('input[name="fulfilment_method"]:checked');
      return checked ? checked.value : '';
    }

    function openImageDialog(trigger) {
      if (!imageDialog || !imageDialogImage || !imageDialogTitle) return;
      imageDialogImage.src = trigger.dataset.imageSrc || '';
      imageDialogImage.alt = trigger.dataset.imageAlt || '';
      imageDialogTitle.textContent = trigger.dataset.imageAlt || '';
      if (typeof imageDialog.showModal === 'function') imageDialog.showModal();
    }

    function closeImageDialog() {
      if (imageDialog && imageDialog.open) imageDialog.close();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-gw-eoi-image-trigger]');
      if (trigger) openImageDialog(trigger);
    });

    if (imageDialogClose) imageDialogClose.addEventListener('click', closeImageDialog);
    if (imageDialog) {
      imageDialog.addEventListener('click', function (event) {
        if (event.target === imageDialog) closeImageDialog();
      });
    }

    function persist() {
      var snapshot = {};
      Array.prototype.forEach.call(form.elements, function (control) {
        if (!control.name || isCustomerField(control) || control.name === 'company_website' || control.type === 'submit' || control.type === 'button') return;
        if (control.type === 'radio') {
          if (control.checked) snapshot[control.name] = control.value;
        } else if (control.type === 'checkbox') {
          snapshot[control.name] = control.checked;
        } else {
          snapshot[control.name] = control.value;
        }
      });
      window.localStorage.setItem(storageKey, JSON.stringify(snapshot));
    }

    function restore() {
      var raw = window.localStorage.getItem(storageKey);
      if (!raw) return;
      try {
        var snapshot = JSON.parse(raw);
        Object.keys(snapshot).forEach(function (name) {
          var control = field(name);
          if (!control || isCustomerField(control)) return;
          if (control instanceof RadioNodeList) {
            Array.prototype.forEach.call(control, function (option) {
              option.checked = option.value === snapshot[name];
            });
          } else if (control.type === 'checkbox') {
            control.checked = snapshot[name] === true;
          } else {
            control.value = snapshot[name];
          }
        });
        setBanner('info', 'Restored your saved draft from this browser.');
      } catch (error) {
        window.localStorage.removeItem(storageKey);
      }
    }

    function formatSydney(value) {
      return new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Sydney',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      }).format(value);
    }

    function updateDeadline() {
      var closesAt = new Date(root.dataset.closesAt || '');
      if (Number.isNaN(closesAt.getTime())) {
        deadline.textContent = 'Expressions of interest close at 3:00 pm Sydney time each Thursday.';
        return;
      }

      closed = Date.now() >= closesAt.getTime();
      deadline.dataset.closed = String(closed);
      deadline.textContent = closed
        ? 'Expressions of interest closed at ' + formatSydney(closesAt) + '. Please email ' + root.dataset.contact + ' if you need help.'
        : 'Expressions of interest close at ' + formatSydney(closesAt) + '.';
      submit.disabled = closed;
      submit.textContent = closed ? 'EOI closed' : 'Submit EOI';
      lineCards.forEach(function (card) {
        card.querySelector('[data-line-quantity]').disabled = closed;
      });
    }

    function buildPayload() {
      var responses = [];
      lineCards.forEach(function (card) {
        var quantity = Number(card.querySelector('[data-line-quantity]').value || '0');
        if (quantity > 0) {
          responses.push({
            line_id: card.dataset.lineId,
            title: card.dataset.lineTitle,
            quantity_requested: quantity,
            preference: 'want',
            note: ''
          });
        }
      });

      return {
        schema_version: 'gw_eoi_response.v1',
        form_id: root.dataset.formId,
        form_token: root.dataset.formToken,
        submitted_at_client: new Date().toISOString(),
        rendered_at_client: new Date(renderedAt).toISOString(),
        dwell_ms: Math.max(0, Date.now() - renderedAt),
        page_url: window.location.href,
        customer: {
          shopify_customer_id: field('customer.shopify_customer_id').value || null,
          email: field('customer.email').value.trim(),
          first_name: field('customer.first_name').value.trim(),
          last_name: field('customer.last_name').value.trim(),
          phone: field('customer.phone').value.trim()
        },
        fulfilment_method: selectedFulfilment(),
        company_website: field('company_website').value.trim(),
        privacy_consent: field('privacy_consent').checked,
        marketing_opt_in: field('marketing_opt_in').checked,
        customer_note: field('customer_note').value.trim(),
        responses: responses
      };
    }

    function validate(payload) {
      var errors = [];
      if (!payload.customer.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.customer.email)) errors.push('Enter a valid email address.');
      if (payload.company_website) errors.push('Spam protection triggered. Please refresh and try again.');
      if (!payload.privacy_consent) errors.push('Confirm the privacy consent statement before submitting.');
      if (['pickup', 'delivery'].indexOf(payload.fulfilment_method) === -1) errors.push('Choose pickup from Wyong or delivery.');
      if (payload.dwell_ms < 2000) errors.push('Please take a moment to review your selections before submitting.');
      if (!payload.responses.length) errors.push('Choose at least one product with a quantity greater than zero.');
      payload.responses.forEach(function (line) {
        if (!Number.isInteger(line.quantity_requested) || line.quantity_requested < 1 || line.quantity_requested > 99) {
          errors.push('Quantities must be whole numbers between 1 and 99.');
        }
      });
      return Array.from(new Set(errors));
    }

    async function handleSubmit(event) {
      event.preventDefault();
      updateDeadline();
      if (closed) return;

      var payload = buildPayload();
      var errors = validate(payload);
      if (errors.length) {
        setBanner('error', errors.join(' '));
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Submitting...';
      setBanner('info', 'Submitting your EOI...');

      try {
        var response = await fetch(root.dataset.endpointUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        });
        var responseText = await response.text();
        var result;
        try {
          result = responseText ? JSON.parse(responseText) : {};
        } catch (parseError) {
          throw new Error('Endpoint returned non-JSON response. HTTP ' + response.status + '.');
        }
        if (!response.ok || result.ok !== true) {
          var detail = result.error_code
            ? result.error_code + ': ' + (result.message || 'Submission failed')
            : (result.message || 'Submission failed');
          throw new Error(detail);
        }

        window.localStorage.removeItem(storageKey);
        form.reset();
        lineCards.forEach(function (card) {
          card.querySelector('[data-line-quantity]').value = '0';
        });
        renderedAt = Date.now();
        setBanner('success', 'Thanks - your expression of interest was received. Receipt ID: ' + (result.receipt_id || 'pending') + '.');
      } catch (error) {
        persist();
        if (window.console && console.error) console.error('[GW EOI] Submission failed', error);
        var errorDetail = error && error.message ? ' Detail: ' + error.message : '';
        setBanner('error', 'We could not submit right now. Your selections remain saved in this browser. Please try again or email ' + root.dataset.contact + '.' + errorDetail);
      } finally {
        updateDeadline();
        if (!closed) {
          submit.disabled = false;
          submit.textContent = 'Submit EOI';
        }
      }
    }

    form.addEventListener('input', persist);
    form.addEventListener('change', persist);
    form.addEventListener('submit', handleSubmit);
    clear.addEventListener('click', function () {
      window.localStorage.removeItem(storageKey);
      form.reset();
      lineCards.forEach(function (card) {
        card.querySelector('[data-line-quantity]').value = '0';
      });
      renderedAt = Date.now();
      setBanner('info', 'Saved draft cleared for this browser.');
    });

    restore();
    updateDeadline();
    window.setInterval(updateDeadline, 60000);
  }

  function initAll() {
    document.querySelectorAll('[data-gw-eoi-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
